import api from './api';
import { ApiResponse, School, SchoolRequest, PageResponse } from '../types';

export const schoolService = {
  getSchools: async (params: {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDir?: 'ASC' | 'DESC';
    search?: string;
  }): Promise<PageResponse<School>> => {
    const response = await api.get<ApiResponse<PageResponse<School>>>('/admin/schools', {
      params: {
        page: params.page || 0,
        size: params.size || 10,
        sortBy: params.sortBy || 'id',
        sortDir: params.sortDir || 'ASC',
        search: params.search || undefined,
      },
    });
    return response.data.data;
  },

  getSchool: async (id: number): Promise<School> => {
    const response = await api.get<ApiResponse<School>>(`/admin/schools/${id}`);
    return response.data.data;
  },

  getSchoolById: async (id: number): Promise<School> => {
    const response = await api.get<ApiResponse<School>>(`/admin/schools/${id}`);
    return response.data.data;
  },

  createSchool: async (school: SchoolRequest): Promise<School> => {
    const response = await api.post<ApiResponse<School>>('/admin/schools', school);
    return response.data.data;
  },

  updateSchool: async (id: number, school: SchoolRequest): Promise<School> => {
    const response = await api.put<ApiResponse<School>>(`/admin/schools/${id}`, school);
    return response.data.data;
  },

  deleteSchool: async (id: number): Promise<void> => {
    await api.delete(`/admin/schools/${id}`);
  },

  getAllSchoolsSimple: async (): Promise<School[]> => {
    const response = await api.get<ApiResponse<PageResponse<School>>>('/admin/schools', {
      params: { page: 0, size: 1000 },
    });
    return response.data.data.content;
  },
};
